// ? When adding columns, remember to update model on the backend.
// ? especially the filterSchema.

export default {
	columns : {
		facilitiesKey : {
			title  : 'ID',
			sort   : 'number',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 0,
		},

		number : {
			title  : 'Facility #',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 1,
		},

		name : {
			title  : 'Facility Name',
			sort   : 'string',
			filter : 'string',
			index  : true,
			weight : 10,
			hidden : false,
			order  : 2,
		},

		owner : {
			title  : 'Owner',
			sort   : 'string',
			filter : 'dropdown',
			index  : true,
			hidden : false,
			order  : 3,
		},

		facilitiesTypeDescription : {
			title        : 'Type',
			sort         : 'string',
			filter       : 'string',
			index        : true,
			weight       : 10,
			hidden       : false,
			order        : 4,
			filterColumn : 'facilitiesType.description',
		},

		status : {
			title  : 'Status',
			sort   : 'string',
			filter : 'dropdown',
			index  : true,
			hidden : false,
			order  : 5,
		},

		normalFlow : {
			title  : 'Norm Cap.',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 6,
		},

		maxFlow : {
			title  : 'Max Cap.',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 7,
		},

		locationDescription : {
			title  : 'Cross Streets',
			sort   : 'string',
			filter : 'string',
			hidden : false,
			order  : 8,
		},
	},

	dropdownOptions : {
		status : {
			defaultText : 'Select a status',
			options     : [
				{
					text  : 'Active',
					value : 'Active'
				},
				{
					text  : 'Abandoned',
					value : 'Abandoned'
				},
			]
		},
		owner : {
			defaultText : 'Select an owner',
			options     : [
				{
					text  : 'Fid',
					value : 'FID'
				},
				{
					text  : 'Private',
					value : 'Private'
				},
			]
		}
	}
};
